
<template>
  <router-view></router-view>
</template>

<script>
import Watermark from "../src/shared/watermark";
export default {
  name: "app",
  data() {
    return {
      zoom: 100,
    };
  },
  created() {
  },
  mounted: function () {
    if (apiConfig.env === "development") {
      Watermark.set("此站点仅供测试");
    }
  },
  // mounted() {
  //   let windowWidth = window.screen.width;
  //   if (windowWidth >= 1920) {
  //     this.ww = 100
  //   }
  //   else if (windowWidth < 1920 && windowWidth >= 1440) {
  //     this.ww = 85
  //   }
  //   else if (windowWidth < 1440 && windowWidth >= 1360) {
  //     this.ww = 100
  //   }
  //   // window.devicePixelRatio = 50
  // }
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~bootstrap/scss/bootstrap";
@import "~bootstrap-vue/src/index.scss";
// Import Main styles for this application
@import "assets/scss/style";

// @import "../node_modules/@syncfusion/ej2-base/styles/material.css";
// @import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
// @import "../node_modules/@syncfusion/ej2-calendars/styles/material.css";
// @import "../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
// @import "../node_modules/@syncfusion/ej2-inputs/styles/material.css";
// @import "../node_modules/@syncfusion/ej2-navigations/styles/material.css";
// @import "../node_modules/@syncfusion/ej2-popups/styles/material.css";
// @import "../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
// @import "../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

.el-message {
  z-index: 9999 !important;
}
</style>
